import { createAction } from '@reduxjs/toolkit';
import User from 'types/entities/User';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const setAffectationConsultantsAction = createAction(
  BaselineAffectationType.SetAffectationConsultants,
  (consultants: User[]) => ({
    payload: { consultants },
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.SetAffectationConsultants:
      return {
        ...state,
        consultants: action?.payload?.consultants,
      };
    default:
      return state;
  }
};
